import * as request from "../utils/request"
import {LoginState} from "./Account"

export function dataReport(params: Record<string, any>, opts: Record<string, any> = {}): void {
  const pu = []
  params[6] = +new Date()
  params[7] = params[7] || 0
  for (const k in params) {
    pu.push(k + "=" + encodeURIComponent(encodeURIComponent(params[k])))
  }

  const pu2 = []
  for (const o in opts) {
    pu2.push("&" + o + "=" + encodeURIComponent(opts[o]))
  }

  request.ajax({
    type: "post",
    url: "//szmg.qq.com/cgi-bin/log_data.fcg",
    data: {
      offer_id: "15499",
      num: 1,
      record0: pu.join("|"),
    },
  })
}
interface ReportParams {
  loginState: LoginState
  resultInfo?: Record<string, any>
  iformat: string
  source?: string
  pf?: string
  offerId: string
}
export function reportUserAction(params: ReportParams): void {
  const data = {
    3: params.loginState.openid,
    8: JSON.stringify(params.resultInfo || ""),
    13: 1,
    21: params.iformat,
    26: `${params.source}-${params.pf || "pay_html5"}-html5`,
    24: params.offerId,
    37: params.loginState.session_id,
    43: params.loginState.session_type,
    41: params.loginState.wx_appid,
    50: navigator.userAgent,
    36: location.href,
  }

  dataReport(data)
}
